import React, { useState } from "react";
import { Link } from "react-router-dom";

import CommentIcon from "../../../../assets/article-comment.svg";
import ArticleDummy from "../../../../assets/article-dummy-1.png";
import { baseURL } from "../../../../misc/http";
import useMouse from "@react-hook/mouse-position";

export default function CardArticles({ data, isEvent }) {
  const ref = React.useRef(null);
  const mouse = useMouse(ref, {
    enterDelay: 50,
    leaveDelay: 50,
  });
  return (
    <>
      <Link
        style={{
          cursor: "pointer",
          padding: 0,
          paddingRight: 10,
          position: "relative",
        }}
        // className="col-4"
        to={`/blog/${data._id}`}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "5px",
            // height: isEvent? 270 : 320,
            boxShadow: "0px 5px 4px rgba(0, 0, 0, 0.06)",
            // overflow:'hidden'
          }}
        >
          {mouse.isOver && (
            <div
              style={{
                color: "rgb(22, 114, 189)",
                // color: 'black',
                // color: "#F2F2F2",
                position: "absolute",
                left: "50%",
                zIndex: 10000,
                left: mouse.x + 60,
                top: mouse.y + 210,
                minWidth: 600,
                fontWeight: "bold",
                fontSize: 15,
              }}
            >
              {data.title}
            </div>
          )}
          <img
            className=""
            src={baseURL + data.picture}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://www.kominfo.go.id/images/default.jpg";
            }}
            alt="images"
            style={{ width: "100%", objectFit: "cover", height: "180px" }}
          />

          <h6
            ref={ref}
            className="h6-nunito"
            style={{ fontWeight: 700, margin: "22px 35px", color: "black" }}
          >
            {data.title.length > 25
              ? data.title
                  .split("")
                  .filter((word, idx) => idx <= 25)
                  .join("") + "..."
              : data.title}
          </h6>
          {data.commentsData && data.category ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0px ",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 35px 30px",
                width: "100%",
              }}
            >
              <p style={{ margin: 0, color: "black" }} className="p-nunito">
                {data.category}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <p
                  style={{ margin: "0px", marginRight: 9, color: "black" }}
                  className="p-nunito"
                >
                  {data.commentsData && data.commentsData.length}
                </p>
                <img
                  className=""
                  src={CommentIcon}
                  alt="commentIcon"
                  style={{ height: "24px", objectFit: "contain" }}
                />
              </div>
            </div>
          ) : (
            <div style={{ height: 15 }} />
          )}
        </div>
      </Link>
    </>
  );
}
